import { useQuery } from "react-query";
import * as wf from "@qpr/client-api-workflow";
import createUICardElement from "backend/utils/createUICardElement";

const useWorkflowConfigurations = () => {
  return useQuery(
    JSON.stringify(["workflow-configurations"]),
    () => {
      return wf.getWorkflowConfigurations().then((items) => {
        return items.map((item) =>
          createUICardElement(item._id || "", "workflowconfig", item)
        );
      });
    },
    {
      cacheTime: 60 * 1000,
    }
  );
};

export default useWorkflowConfigurations;
